import "sitecss/inner.css";
//import * as util from "./site";
import * as qtipval from "./jquery.qtip.validation";
//import "toastr";


declare global {
    interface Window {
        unHighlightField?: Function;
    }
}
//function innerInit() {
//    util.messageBoxOk("hello", "hey, here's a message");
//    //Object.assign(window, util);
//    //Object.assign(window, qtipval);
//    //if (window.DoNotInitQtipVal != true) qtipval.qTipValInit();
//}

//innerInit();

//import * as util from "./site";
//util.messageBoxOk("hello", "hey, here's a message");
window.unHighlightField = qtipval.unHighlightField;

qtipval.qTipValInit();
